export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9593.a12ee86e.jpg";